import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

export default function RadioButton({ tempeng, data, idofclass, setIsselected, language2, languagecode2, setTempeng, setShowspinner, showspinner, setSelectedclass, selectedclass, pickindex, setPickindex, num, setNum, classid }) {

  console.log(language2, tempeng, languagecode2);

  const [height, setHeight] = useState();
  const [height2, setHeight2] = useState(0);

  const scrollview_ref = useRef();

  useEffect(() => {
    if (height > height2) {
      setHeight2(height)
    } else {
      setHeight2(height2)
    }
  }, [height]);



  useEffect(() => {
    if (typeof num != "undefined") {
      setPickindex(num)
    }
  }, [num]);

  const selectHandler = (value, i) => {
    if (value.id != idofclass) {
      setSelectedclass(value);
      setNum(i);
    }
    else {
      setSelectedclass("");
    }
  };

  useEffect(() => {
    if (typeof num != "undefined" && typeof pickindex != "undefined") {
      startAnimation();
      console.log(pickindex, height2, "pick indexxxx")
    }
  }, [pickindex, height2]);

  const startAnimation = () => {
    if (scrollview_ref.current) {
      if (pickindex === 0) {
        scrollview_ref.current.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else if (pickindex === 1) {
        scrollview_ref.current.scrollTo({
          top: 115,
          behavior: 'smooth'
        });
      } else {
        scrollview_ref.current.scrollTo({
          top: (pickindex * 115) + 0,
          behavior: 'smooth'
        });
      }
    }
  };

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");

  useEffect(() => {
    if (languagecode2 != "" && language2 != "English" && typeof language2 != "undefined") {
      console.log(languagecode2, "this is the languagec code");
      getStoredLanguage();
    }
  }, [languagecode2]);

  const getStoredLanguage = async () => {
    try {
      const value = localStorage.getItem('insideavailableclasseslanguagecode2');
      if (value !== null && value == languagecode2) {
        console.log("17 The language HAS BEEN SET.")
        getData0();
        getData1();
        getData2();
        getData3();
      } else {
        console.log("29 The language has NOT YET been set. ")
        localStorage.setItem('insideavailableclasseslanguagecode2', languagecode2);
        getnewlanguaage0();
        getnewlanguaage1();
        getnewlanguaage2();
        getnewlanguaage3();
      }
    } catch (e) {
      console.log("SOMETHING WENT WRONG HERE!!!")
    }
  };

  const getData0 = async () => {
    try {
      const value = localStorage.getItem('insideavailableclassestext0');
      if (value !== null) {
        setText0(value);
      }
      else {
        getnewlanguaage0();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData1 = async () => {
    try {
      const value = localStorage.getItem('insideavailableclassestext1');
      if (value !== null) {
        setText1(value);
      }
      else {
        getnewlanguaage1();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData2 = async () => {
    try {
      const value = localStorage.getItem('insideavailableclassestext2');
      if (value !== null) {
        setText2(value);
      }
      else {
        getnewlanguaage2();
      }
    } catch (e) {
      // error reading value
    }
  };

  const getData3 = async () => {
    try {
      const value = localStorage.getItem('insideavailableclassestext3');
      if (value !== null) {
        setText3(value);
      }
      else {
        getnewlanguaage3();
      }
    } catch (e) {
      // error reading value
    }
  };

  useEffect(() => {
    if (text0 != "" && text1 != "" && text2 != "" && text3 != "") {
      setTimeout(() => {
        setTempeng(false);
        setShowspinner(false);
      }, 2000);
    }
  }, [text0, text1, text2, text3]);

  const getnewlanguaage0 = async () => {
    console.log("this is the language code2", languagecode2);

    if (languagecode2 != "en" && languagecode2 != "") {
      setShowspinner(true);
      console.log("this is the language code", languagecode2)

      try {
        const response = await axios.post("https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY", {
          source: "en",
          format: "text",
          q: "Period",
          target: `${languagecode2}`,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setText0(response.data.data.translations[0].translatedText);
        localStorage.setItem('insideavailableclassestext0', response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  const getnewlanguaage1 = async () => {
    console.log("this is the language code2", languagecode2);

    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post("https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY", {
          source: "en",
          format: "text",
          q: "Class",
          target: languagecode2,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setText1(response.data.data.translations[0].translatedText);
        localStorage.setItem('insideavailableclassestext1', response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  const getnewlanguaage2 = async () => {
    console.log("this is the language code2", languagecode2);

    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post("https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY", {
          source: "en",
          format: "text",
          q: "Teacher",
          target: `${languagecode2}`,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setText2(response.data.data.translations[0].translatedText);
        localStorage.setItem('insideavailableclassestext2', response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  const getnewlanguaage3 = async () => {
    console.log("this is the language code", languagecode2);
    if (languagecode2 != "en" && languagecode2 != "") {
      try {
        const response = await axios.post("https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY", {
          source: "en",
          format: "text",
          q: "Room",
          target: `${languagecode2}`,
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setText3(response.data.data.translations[0].translatedText);
        localStorage.setItem('insideavailableclassestext3', response.data.data.translations[0].translatedText);
      } catch (error) {
        console.error('Error:', error);
      }

      setShowspinner(false);
    }
  }

  // Styles converted to CSS-in-JS format
  const styles = {
    scrollView: {
      maxHeight: '500px',
      overflowY: 'auto',
      padding: '10px'
    },
    itemContainer: {
      margin: '6px'
    },
    unselected: {
      backgroundColor: '#013469',
      textAlign: "center",
      fontSize: '17px',
      margin: '6px',
      flex: 1,
      color: "#ffffff",
      border: '3px solid #013469',
      padding: '10px',
      cursor: 'pointer',
      borderRadius: '6px'
    },
    selected: {
      color: "#fff",
      backgroundColor: "#013469",
      border: '3px solid #E43522',
      margin: '6px',
      fontSize: '20px',
      borderRadius: '20px',
      textAlign: "center",
      marginLeft: '25px',
      marginRight: '25px',
      padding: '10px',
      cursor: 'pointer'
    },
    spinner: {
      position: 'absolute',
      textAlign: 'center',
      width: '100%',
      height: '100%',
      display: showspinner ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    },
    spacer: {
      marginBottom: '100px'
    }
  };

  return (
    <>
      {language2 !== "English" && tempeng !== true ? (
        <div className="scroll-view" ref={scrollview_ref} style={styles.scrollView}>
          {data && data.map((item, i) => (
            <div key={i} style={styles.itemContainer}>
              <div 
                style={item.id === idofclass ? styles.selected : styles.unselected}
                onClick={() => selectHandler(item, i)}
              >
                {text0}: {item.period} <br />
                {text1}: {item.classname} <br />
                {text2}: {item.teacheriscalled} <br />
                {text3}: {item.location}
              </div>
            </div>
          ))}
          
          {showspinner && (
            <div style={styles.spinner}>
              <div className="spinner"></div>
            </div>
          )}
          
          <div style={styles.spacer}></div>
        </div>
      ) : (
        <div className="scroll-view" ref={scrollview_ref} style={styles.scrollView}>
          {data && data.map((item, i) => (
            <div key={i} style={styles.itemContainer}>
              <div 
                style={item.id === idofclass ? styles.selected : styles.unselected}
                onClick={() => selectHandler(item, i)}
              >
                Period: {item.period} <br />
                Class: {item.classname} <br />
                Teacher: {item.teacheriscalled} <br />
                In Room: {item.location}
              </div>
            </div>
          ))}
          
          {showspinner && (
            <div style={styles.spinner}>
              <div className="spinner"></div>
            </div>
          )}
          
          <div style={styles.spacer}></div>
        </div>
      )}
    </>
  );
}
